import { render, staticRenderFns } from "./addPurchaseStorage.vue?vue&type=template&id=59a94728&scoped=true&"
import script from "./addPurchaseStorage.vue?vue&type=script&lang=js&"
export * from "./addPurchaseStorage.vue?vue&type=script&lang=js&"
import style0 from "./addPurchaseStorage.vue?vue&type=style&index=0&id=59a94728&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a94728",
  null
  
)

export default component.exports